/* eslint-disable react/jsx-no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Chip, CircularProgress, Divider, Grid, MenuItem, Modal, TextField, Typography } from '@mui/material';
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { checkUserAlreadyExist, deleteUserAdvertiser, resetIAMFormData } from '../../redux/user/userActions';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { connect } from 'react-redux';
import { gridSpacing } from 'store/constant';
import { useNavigate } from 'react-router-dom';

const DeleteUser = ({
  deleteUserAdvertiser,
  resetIAMFormData,
  error,
  userLoginForDashboardAlreadyExist,
  onboardedToDashboard,
  showModal,
  closeModal
}) => {
  const [open, setOpen] = React.useState(showModal);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    advertiserGuid: ''
  });
  const [errors, setErrors] = useState({
    email: '',
    advertiserGuid: '',
    message: ''
  });

  const handleClose = () => {
    setOpen(false);
    closeModal(false);
    resetIAMFormData();
  };

  const navigate = useNavigate();

  useEffect(() => {
    console.log('checkUserAlreadyExistOnDashboard', userLoginForDashboardAlreadyExist);
    if (userLoginForDashboardAlreadyExist === false && formData.email != '') {
      let prevError = errors.email;
      console.log('prev Error', errors.email);
      setErrors((prevErrors) => ({
        ...prevErrors,
        ['email']: prevError
      }));
    }
  }, [userLoginForDashboardAlreadyExist]);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  useEffect(() => {
    console.log('error', error);
  }, [error]);

  const validateField = (name, value) => {
    let error = '';
    if (name === 'advertiserGuid' && value.trim() === '') {
      error = 'Advertiser Guid is required';
    } else if (name === 'email' && !validateEmail(value)) {
      error = 'Invalid email address';
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    validateField(name, value);
  };

  const openAdvertiserList = () => {
    navigate('/advertisers', { replace: true });
    setOpen(false);
  };

  const handleAdvertiser = async () => {
    // Validate required fields
    const emailError = !validateEmail(formData.email) ? 'Invalid email address' : '';
    const advertiserGuidError = formData.advertiserGuid.trim() === '' ? 'Advertiser Guid is required' : '';

    setErrors((prev) => ({
      ...prev,
      email: emailError,
      advertiserGuid: advertiserGuidError
    }));

    // If validation fails, don't proceed
    if (emailError || advertiserGuidError) {
      return;
    }

    setLoading(true);
    // Format data to match backend API requirements
    const formattedData = {
      email_id: formData.email,
      advertisers: [
        {
          id: formData.advertiserGuid
        }
      ]
    };

    console.log('Sending delete request with data:', formattedData);
    deleteUserAdvertiser(formattedData);

    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={2} md={10} sm={8} xs={6}></Grid>
        <Grid item lg={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                sx={{
                  textAlign: 'center',
                  mb: 3,
                  p: 2,
                  backgroundColor: '#fdecea', // light pastel red
                  borderRadius: 2,
                  border: '1px solid #f5c2c7' // soft border
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    color: '#842029' // softer dark red for text
                  }}
                >
                  Delete User Advertiser Details
                </Typography>
                {/* <Typography variant="body2" sx={{ 
                  fontStyle: 'italic',
                    color: '#842029'
                }}>
                  Remove advertiser access for a user
                </Typography> */}
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                name="email"
                label="Email Address"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email || "Enter the user's email address"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                name="advertiserGuid"
                label="Advertiser GUID"
                value={formData.advertiserGuid}
                onChange={handleChange}
                error={!!errors.advertiserGuid}
                helperText={errors.advertiserGuid || 'Enter the advertiser GUID to remove access for'}
              />
            </Grid>

            <Grid item xs={12}>
              {/* Updated button styles to match AddUser.js */}
              {(() => {
                const buttonStyles = {
                  width: '9em',
                  height: '3em',
                  borderRadius: '30em',
                  fontSize: '15px',
                  fontFamily: 'inherit',
                  border: 'none',
                  position: 'relative',
                  overflow: 'hidden',
                  zIndex: 1,
                  boxShadow: '6px 6px 12px rgb(255, 255, 255), -6px -6px 12px #ffffff',
                  background: '#e8e8e8',
                  cursor: 'pointer',
                  textTransform: 'none',
                  fontWeight: 500,
                  color: '#090909',
                  '&::before': {
                    content: '""',
                    width: 0,
                    height: '3em',
                    borderRadius: '30em',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    backgroundImage: 'linear-gradient(to right, rgb(15, 203, 216) 0%, rgb(71, 154, 249) 100%)',
                    transition: '.5s ease',
                    display: 'block',
                    zIndex: -1
                  },
                  '&:hover::before': {
                    width: '9em'
                  },
                  '&:disabled': {
                    opacity: 0.6,
                    cursor: 'not-allowed'
                  }
                };

                const statusIconStyles = {
                  color: '#22ae2d',
                  fontSize: 18
                };

                const errorIconStyles = {
                  color: '#e53935',
                  fontSize: 18
                };

                return (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 2,
                      mt: 3,
                      flexWrap: 'wrap'
                    }}
                  >
                    <Button
                      onClick={() => {
                        openAdvertiserList();
                      }}
                      variant="text"
                      sx={buttonStyles}
                    >
                      Cancel
                    </Button>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Button onClick={handleAdvertiser} variant="text" disabled={loading} sx={buttonStyles}>
                        {loading ? <CircularProgress size={16} color="inherit" /> : 'Delete Advertiser'}
                      </Button>
                      {onboardedToDashboard && <CheckCircleIcon sx={statusIconStyles} />}
                      {error && !onboardedToDashboard && <CancelIcon sx={errorIconStyles} />}
                    </Box>
                  </Box>
                );
              })()}
            </Grid>

            {errors.message && (
              <Grid item xs={12}>
                <Typography color="error">{errors.message}</Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item lg={2} md={10} sm={8} xs={6}></Grid>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    onboardedToDashboard: state.userReducer.onboardedToDashboard,
    userLoginForDashboardAlreadyExist: state.userReducer.userLoginForDashboardAlreadyExist,
    error: state.userReducer.error
  };
};

const mapDispatchToProps = {
  resetIAMFormData: resetIAMFormData,
  checkUserAlreadyExist: checkUserAlreadyExist,
  deleteUserAdvertiser: deleteUserAdvertiser
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteUser);
